import { Fighter } from '../models/fighter.model';
import { FighterInfo } from '../models/fighterInfo.model';
import { SeasonFights } from '../models/seasonFights.model';
import { formatDateLong, parseSafeDate } from './date.utils';
import { getDefaultFighterImage } from './fighterImage.utils';

export const createFighterInfo = (
  position: number,
  fighter: Fighter,
  imageSrc: string,
  fight: SeasonFights,
  points: number | null,
): FighterInfo | string => {
  // Create fighter's full name for comparison
  const fighterFullName = `${fighter.firstname} ${fighter.lastname}`;

  // Determine if the fighter is fighter_1 or fighter_2
  const isFighterOne = fight.fighter_1_id === fighter.id;
  const isFighterTwo = fight.fighter_2_id === fighter.id;

  if (!isFighterOne && !isFighterTwo) {
    console.error(`Fighter ${fighterFullName} not found in fight:`, fight);
    return `Fighter ${fighterFullName} not found in this fight`;
  }

  // Get opponent id and name
  const opponentName = isFighterOne ? fight.fighter_2 : fight.fighter_1;

  // Create and return the fighter info object
  return {
    CardId: position,
    FightId: fight.fight_id,
    FighterId: fighter.id,
    FighterImage: imageSrc || getDefaultFighterImage(fighter.gender),
    FighterName: fighterFullName,
    Firstname: fighter.firstname,
    Lastname: fighter.lastname,
    Dob: fighter.dob,
    Opponent: opponentName,
    FightDate: formatDateLong(parseSafeDate(fight.date)),
    Points: points,
    Title: fight.title_fight || '',
    Gender: fighter.gender,
  };
};
